import {
  BooklaAdminCompanySettings,
  CompanyContact,
  CompanyContent,
  CompanyDetails,
  CompanyTranslation,
} from '@src/@data/types/company';
import { Image } from '@src/@data/types/common';

export const enum CompanyActionType {
  SET_COMPANY,
  CLEAR_COMPANY,
  UPDATE_TRANSLATIONS,
  UPDATE_CONTACTS,
  UPDATE_CONTENT,
  UPDATE_IMAGE,
  UPDATE_ENABLED,
  LEGAL_INFO_UPDATED,
  UPDATE_ADMIN_SETTINGS,
}

export type CompanyAction =
  | { type: CompanyActionType.SET_COMPANY; company: CompanyDetails }
  | { type: CompanyActionType.CLEAR_COMPANY }
  | {
      type: CompanyActionType.UPDATE_TRANSLATIONS;
      translations: CompanyTranslation[];
    }
  | { type: CompanyActionType.UPDATE_CONTACTS; contacts: CompanyContact[] }
  | { type: CompanyActionType.UPDATE_CONTENT; content: CompanyContent }
  | { type: CompanyActionType.UPDATE_IMAGE; image: Image }
  | { type: CompanyActionType.UPDATE_ENABLED; enabled: boolean }
  | { type: CompanyActionType.LEGAL_INFO_UPDATED }
  | {
      type: CompanyActionType.UPDATE_ADMIN_SETTINGS;
      settings: BooklaAdminCompanySettings;
    };
